import UserSetting from "../components/userSetting/UserSetting";
import { AppLayout } from "../layout/AppLayout";

function Settings() {
  return (
    <AppLayout>
      <div className="container grid place-items-center pt-10">
        <UserSetting />
        {/* {location.pathname.includes("profile") ? (
          <UserProfile />
        ) 
        : location.pathname.includes("security") ? 
        (<UserSecurity />) 
        : (
          <UserSetting />
        )} */}
      </div>
    </AppLayout>
  );
}

export default Settings;
